import Form from "react-bootstrap/Form";
import "../../../src/main.css";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import moment from "moment";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";
import xlsx from "json-as-xlsx";
import { useNavigate } from "react-router-dom";
import {
  getFormattedStartDate,
  getFormattedEndDate,
  revenueRepStartDate,
  revenueRepEndDate,
} from "functionCall";
// import { getFormattedDate } from 'modules/utilities/utility';
import {
  formatDate,
  decreaseDateByOneDay,
  getMaxDate_,
  getMinDate_,
} from "modules/utilities/utility";

function ActivityLoggerFilter(props) {
  const [startDate, setStartDate] = useState(
    new Date(Date.now() - 24 * 60 * 60 * 1000)
  );
  const [endDate, setEndDate] = useState(new Date());
  const navigate = useNavigate();

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  const handleResetStartDate = () => {
    // setStartDate("");
    setStartDate(new Date(Date.now() - 24 * 60 * 60 * 1000));
  };
  const handleResetEndDate = () => {
    setEndDate(new Date());
    // setEndDate("");
  };

  // const formatDate = (date) => {
  //   return format(date, "yyyy-MM-dd");
  // };
  // function decreaseDateByOneDay(dateString) {
  //   return moment(dateString).subtract(1, "day").format("YYYY-MM-DD");
  // }

  const handleFilterSubmit = (event) => {
    event.preventDefault();

    const encodeStartDate = encodeURIComponent(revenueRepStartDate(startDate));
    const encodeEndDate = encodeURIComponent(revenueRepEndDate(endDate));
    if (startDate && endDate) {
      navigate(
        `/slot-booking-loggers?pageNumber=1&sd=${encodeStartDate}&ed=${encodeEndDate}`
      );
    } else {
      setStartDate(new Date(Date.now() - 24 * 60 * 60 * 1000));
      setEndDate(new Date());
      navigate(
        `/slot-booking-loggers?pageNumber=1&sd=${encodeURIComponent(
          revenueRepStartDate(getFormattedEndDate(1))
        )}&ed=${encodeURIComponent(revenueRepEndDate(getFormattedStartDate()))}`
      );
    }
  };

  return (
    <>
      <div className="d-flex align-items-end justify-content-end pt-3">
        <Form onSubmit={handleFilterSubmit} className="data-filter">
          <div className="d-flex gap-2">
            <Form.Group>
              <div className="input-container mt-1">
                {startDate ? (
                  ""
                ) : (
                  <div className="calendar-icon-container">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="calendar-icon"
                    />
                  </div>
                )}
                <DatePicker
                  selected={startDate}
                  onChange={handleStartDateChange}
                  placeholderText="Start Date"
                  dateFormat="dd-MM-yyyy"
                  value={startDate ? formatDate(startDate) : ""}
                  className="input-with-icon"
                  minDate={getMinDate_(endDate)}
                  maxDate={endDate}
                />
                {startDate && (
                  <span className="reset-icon" onClick={handleResetStartDate}>
                    <BsX />
                  </span>
                )}
              </div>
            </Form.Group>
            <Form.Group>
              <div className="input-container mt-1">
                {endDate ? (
                  ""
                ) : (
                  <div className="calendar-icon-container">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="calendar-icon"
                    />
                  </div>
                )}
                <DatePicker
                  selected={endDate}
                  onChange={handleEndDateChange}
                  placeholderText="End Date"
                  dateFormat="dd-MM-yyyy"
                  value={endDate ? formatDate(endDate) : ""}
                  maxDate={getMaxDate_(startDate)}
                  minDate={
                    new Date(endDate.getTime() - 2 * 24 * 60 * 60 * 1000)
                  }
                />
                {endDate && (
                  <span className="reset-icon" onClick={handleResetEndDate}>
                    <BsX />
                  </span>
                )}
              </div>
            </Form.Group>
            <Button variant="primary" className="mt-1 w-100" type="submit">
              Filter
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}
export default ActivityLoggerFilter;
